import { PropsWithChildren } from "react";
import NavMenu from "./NavMenu";
import Header from "./Header";
import { Box, CircularProgress, useTheme } from "@mui/joy";
import React from "react";
import { Util } from "./Helpers/Util";
import { RoleProvider, useRole } from "./Contexts/RoleContext";
import SmsTermsDialog from "./Dialogs/SmsTermsDialog";

interface LayoutProps {}

function LayoutInner(props: PropsWithChildren<LayoutProps>) {
	const theme = useTheme();
	const [loading, setLoading] = React.useState(true);
	const [smsTermsOpen, setSmsTermsOpen] = React.useState(false);
	const { setActualRole } = useRole();

	React.useEffect(() => {
		fetch("/User/GetPersonInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((y) => {
				setLoading(false);
				Util.CurrentRole = y.role;
				setActualRole(y.role);
				if (y.sms_terms_prompt_needed === true)
					setSmsTermsOpen(true);
			});
	}, []);

	const onSmsResolved = () => {
		setSmsTermsOpen(false);
	};

	return loading ? (
		<CircularProgress />
	) : (
		<div style={{ display: "flex", height: "100%", overflow: "hidden" }}>
			<SmsTermsDialog open={smsTermsOpen} onResolved={onSmsResolved} />
			<NavMenu />
			<Box
				sx={{
					flex: 1,
					minWidth: 0,
					minHeight: 0,
					display: "flex",
					flexDirection: "column",
					p: 2,
					backgroundColor: theme.palette.background.body,
				}}>
				<Header />
				<Box sx={{ flex: 1, minWidth: 0, minHeight: 0, overflow: "auto", display: "flex", flexDirection: "column" }}>
					{props.children}
				</Box>
			</Box>
		</div>
	);
}

export default function Layout(props: PropsWithChildren<LayoutProps>) {
	return (
		<RoleProvider>
			<LayoutInner {...props} />
		</RoleProvider>
	);
}